import React, { useEffect, useState, Suspense } from "react";
import { Modal, Button } from "react-bootstrap";
import Enlaces from "./enlaces/Enlaces";
import Informes from "./informes/Informes";
import ModalInit from "../../layout/Modal/ModalInit";
import { dataCAR } from "../../data/2024/dataCarouselIndex";
import { dataInformes } from "../../data/dataInformes";
import { modalsInitData } from "../../data/2024/dataIndex";
import CarouselSecundarios from "./CarouselSecundarios";
import Micrositios from "./Micrositios";
import Slider from "./Slider";
import JudicialButton from "./JudicialButton";
import CountdownElectoral from "./CountdownElectoral";
import Sitios from "./Sitios";
import VideosINE from "./VideosINE";
import "./Home.css";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";
import "@justinribeiro/lite-youtube";
import LoadingSpinner from "../../components/LoadingSpinner";
import Estrados from "./Estrados";
import CalendarioSesiones from "../../components/Home/Calendario/CalendarioSesiones";
import EncabezadoSeccion from "../../components/EncabezadoSeccion";
import useRevealOnScroll from "../../hooks/useRevealOnScroll";

const MODALS_API = "https://sigec.test/api/ordenes-del-dia";

const ITE = () => {
  const registerReveal = useRevealOnScroll();
  const [initialLoad, setInitialLoad] = useState(false);
  const [modals, setModals] = useState(modalsInitData);

  useEffect(() => {
    document.title = "ITE";
    const timer = setTimeout(() => setInitialLoad(true), 300);

    const controller = new AbortController();
    const fetchTimeout = setTimeout(() => controller.abort(), 800);

    fetch(MODALS_API, { signal: controller.signal })
      .then((res) => (res.ok ? res.json() : []))
      .then((data) => {
        clearTimeout(fetchTimeout);
        if (Array.isArray(data) && data.length > 0) {
          setModals(data);
        } else {
          setModals(modalsInitData);
        }
      })
      .catch((err) => {
        clearTimeout(fetchTimeout);
        setModals(modalsInitData);
      });

    return () => clearTimeout(timer);
  }, []);

  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState("");

  const handleOpenModal = (imageUrl) => {
    setModalImage(imageUrl);
    setShowModal(true);
  };

  const handleImageClick = (e, item) => {
    e.preventDefault();
    handleOpenModal(`https://itetlax.org.mx/assets/img/imgC_AR/${item.imgUrl}`);
  };

  return (
    <>
      {modals.map((modal) => (
        <ModalInit
          key={modal.id}
          imgLink={modal.imgLink}
          url={modal.url}
          linkToo={modal.linkToo}
        />
      ))}

      <div className="full-width-wrapper" style={{ marginTop: "-20px" }}>
        <Slider />
      </div>

      {initialLoad && (
        <Suspense fallback={<LoadingSpinner />}>
          <CountdownElectoral />
          {/* <JudicialButton /> */}
          {/* Calendario de Sesiones - Ancho Completo (100%) */}
          <br></br>
          {/* <div className="row my-4">
            <div className="col-12">
              <CalendarioSesiones />
            </div>
          </div> */}

          <div ref={registerReveal}>
            <EncabezadoSeccion titulo="Enlaces" />
            <Enlaces />
          </div>

          <br></br>
          <br></br>

          <div ref={registerReveal}>
            <CarouselSecundarios
              dataCAR={dataCAR}
              handleImageClick={handleImageClick}
            />
          </div>

          <div ref={registerReveal}>
            <Micrositios />
          </div>

          <br></br>
          <br></br>

          <div ref={registerReveal}>
            <EncabezadoSeccion titulo="Documentos e informes de interés" />
            <Informes items={dataInformes} itemsID={"itemsInformes"} />
          </div>

          <br></br>
          <br></br>
          <br></br>

          <div ref={registerReveal}>
            <Estrados />
          </div>

          <br></br>
          <br></br>

          <EncabezadoSeccion
            titulo="Videos INE"
            fallback={<h3 className="bottom_title mt-5 enlaces-custom">Videos INE</h3>}
          />
          <VideosINE />
          <br></br>
          <div ref={registerReveal}>
            <EncabezadoSeccion titulo="Sitios de interés" />
            <Sitios />
          </div>

          {/* MODAL RETIRADO (COMENTADO SEGÚN SOLICITUD)
          <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Body className="text-center p-0">
              <div className="position-relative">
                <img
                  src={modalImage}
                  alt="Imagen del Modal"
                  className="img-fluid w-100"
                />
          
                <div className="position-absolute bottom-0 w-100 d-flex">
                  <Button
                    style={{
                      backgroundColor: "#5d2872",
                      borderColor: "white",
                      borderWidth: "2px",
                      borderStyle: "solid",
                      color: "white",
                      width: "50%",
                      borderRadius: "0",
                      fontWeight: "bold",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.5)",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = "#8a5a9b";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = "#5d2872";
                    }}
                    onClick={() =>
                      window.open(
                        "https://itetlax.org.mx/assets/pdf/carousel/Formulario.pdf",
                        "_blank"
                      )
                    }
                  >
                    DESCARGAR FORMULARIO
                  </Button>

                  <Button
                    style={{
                      backgroundColor: "#e55398",
                      borderColor: "white",
                      borderWidth: "2px",
                      borderStyle: "solid",
                      color: "white",
                      width: "50%",
                      borderRadius: "0",
                      fontWeight: "bold",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.5)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = "#ff7faf";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = "#e55398";
                    }}
                    onClick={() =>
                      window.open(
                        "https://docs.google.com/forms/d/e/1FAIpQLSdZb2vkV6LQwamOR7zY3XC_gIHwkq-qbuQoAiWm6rQWQx6Ktg/viewform",
                        "_blank"
                      )
                    }
                  >
                    FORMULARIO EN LÍNEA
                  </Button>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
              <Button variant="danger" onClick={() => setShowModal(false)}>
                Cerrar
              </Button>
            </Modal.Footer>
          </Modal>
          */}
        </Suspense>
      )}
      <style jsx global>{`
        .custom-modal .modal-content {
          overflow: hidden;
          border-radius: 12px;
          border: none;
          max-width: 900px;
          margin: 0 auto;
        }

        .btn-hover-effect:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15) !important;
          opacity: 0.95;
          cursor: pointer;
        }

        .btn-hover-effect:active {
          transform: translateY(1px);
        }

        @media (min-width: 992px) {
          .custom-modal .modal-body {
            flex-direction: row !important;
            align-items: center;
          }
          .custom-modal .modal-body > div:first-child {
            width: 60% !important;
            height: 100% !important;
            max-height: none !important;
            min-height: 100% !important;
          }
          .custom-modal .modal-body > div:last-child {
            width: 40% !important;
            height: 100% !important;
            justify-content: center;
            padding-top: 0 !important;
            padding-bottom: 0 !important;
          }
        }

        @media (max-width: 991.98px) {
          .custom-modal .modal-body > div:first-child {
            height: 50vh !important;
            max-height: none !important;
          }
          .custom-modal .modal-body > div:last-child {
            min-height: fit-content;
          }
        }
      `}</style>
    </>
  );
};

export default ITE;
